import { URLS } from '~/constants';
import OsDetector from 'device-detector-js/dist/parsers/operating-system';
import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import { complement, map, pipe, take } from 'ramda';
import { IO } from 'ramda-fantasy';

const popupUrlRegex = () => /\/messenger\/popup\/\d{19}/g;

const { userAgent } = window.navigator;

const osInfo = new OsDetector().parse(userAgent);

export const getSubDomain = (host = window.location.host) => {
  const subDomain = host.split('.')[0];
  return !/(local|dev|alpha|beta|stage|enf)/.test(subDomain) ? subDomain : '';
};

// 일렉트론
export const isElectron = () => /Electron/.test(userAgent);

// 윈도우 네이티브
export const isWinNative = () => isChromium() || isWebView2();

export const isChromium = () => /DoorayMessenger.+Chromium/.test(userAgent);

export const isWebView2 = () => /Edg.+DoorayMessenger/.test(userAgent);

// 네이티브 앱
export const isNative = () => isElectron() || isWinNative();

// 새 창
export const isPopupView = () => popupUrlRegex().test(window.location.href);

// 메인 창
export const isMainView = complement(isPopupView);

// 일렉트론 메인 창
export const isElectronMainView = () => isElectron() && isMainView();

export const isBrowser = () => !isElectron();

export const getQueryParameterByName = (name, url = window.location.href) => {
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return window.decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const getPort = () => {
  const { port } = window.location;
  return isEmpty(port) ? '' : `:${port}`;
};

export const getBrowserLanguage = () => {
  return IO.of(window.navigator.language);
};

export const getBrowserTimezone = () => {
  return IO.of(moment.tz.guess());
};

export const getHost = () => {
  return window.location.host;
};

export const getDefaultLocale = () => {
  return pipe<any, any, any>(map(take(2)), IO.runIO)(getBrowserLanguage());
};

export const getDefaultTimezone = () => {
  return getBrowserTimezone().runIO();
};

export const isWindows = () => {
  return osInfo.name.toLowerCase().indexOf('windows') > -1;
};

export const isIE = () => {
  const agent = navigator.userAgent.toLowerCase();
  return (navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1;
};

const getProtocol = () => {
  return window.location.protocol;
};

export const getWebsocketProtocol = () => {
  return getProtocol() === 'https:' ? 'wss' : 'ws';
};

export const getUrlByEnv = (key: keyof typeof URLS) => {
  return URLS[key];
};

const runEnvironment = {
  os: osInfo.name,
  isIE,
  getPort,
  getProtocol,
  getWebsocketProtocol,
};
export default runEnvironment;
